export const TransferMoneyFormFields = {
  Amount: 'amount',
  Method: 'method'
};

export const normalizeDecimalComma = (value?: number) =>
  value ? value.toString().replace('.', ',') : '0';
